module.exports = __webpack_public_path__ + "static/media/3.a04c9e88.jpg";